import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Profile = {
  id: string;
  email: string;
  role: 'admin' | 'user';
  full_name: string | null;
  created_at: string;
  updated_at: string;
};

export type User = Profile;

export type EntryType = {
  id: string;
  name: string;
  entry_category: 'income' | 'expense';
  is_default: boolean;
  is_deletable: boolean;
  display_order: number;
  created_at: string;
};

export type WeeklyLedger = {
  id: string;
  date: string;
  created_by: string;
  notes: string | null;
  created_at: string;
  updated_at: string;
};

export type LedgerEntry = {
  id: string;
  weekly_ledger_id: string;
  entry_type_id: string;
  amount: number;
  created_at: string;
  updated_at: string;
};

export type Invitation = {
  id: string;
  email: string;
  token: string;
  created_by: string | null;
  status: 'pending' | 'accepted' | 'expired';
  expires_at: string;
  created_at: string;
};

export type UserPreference = {
  id: string;
  user_id: string;
  preferred_language: string;
  created_at: string;
  updated_at: string;
};

export type DailyTimestamp = {
  id: string;
  timestamp: string;
  log_date: string;
  created_at: string;
};
